export default "__VITE_ASSET__5HP9$a9y__"